<template>
  <div>
    <slot name="title">
      <p class="uppercase text-xs font-medium text-gray-600" v-if="title">{{ title }}</p>
    </slot>
    <div v-for="(row, index) in value" :key="index">
      <hr class="mt-6 mb-4" v-if="index > 0 && separator" />
      <div class="flex">
        <base-form
          v-if="formHasVisibleFields"
          v-model="value[index]"
          class="w-full"
          :config="config"
          :error="getError(index)"
          @change="onChange($event, index)"
        >
          <template v-for="field in config" #[getSlotName(field)]>
            <slot :name="getSlotName(field)" :field="field" :index="index"></slot>
          </template>
        </base-form>
        <div class="mt-px pt-1 pl-3">
          <base-button
            class="is-gray-300 text-lg"
            :disabled="!canDelete"
            @click="deleteRow(row, index)"
            square
            rounded
            xsmall
          >
            <span class="icon icon-remove" />
          </base-button>
        </div>
      </div>
    </div>
    <base-button-icon
      class="mt-2"
      button-classes="is-blue-500 text-xl"
      v-if="canAdd"
      @click="addRow"
      square
      rounded
      small
    >
      {{ addLabel }}
    </base-button-icon>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    config: Array,
    minRows: Number,
    maxRows: Number,
    title: String,
    error: Array,
    preventDelete: {
      type: Boolean,
      default: false
    },
    separator: {
      type: Boolean,
      default: false
    },
    addLabel: {
      type: String,
      default: "Add"
    }
  },
  created() {
    if (this.minRows && this.value.length < this.minRows) {
      for (let index = 0; index <= this.minRows - this.value.length; index++) {
        this.addRow();
      }
    }
  },
  computed: {
    canAdd() {
      return this.value.length < this.maxRows || !this.maxRows;
    },
    canDelete() {
      return this.value.length > this.minRows || !this.minRows;
    }
  },
  methods: {
    getSlotName(field) {
      return `field(${field.modelKey})`
    },
    getError(index) {
      return this.error && this.error.length > index ? this.error[index] : null;
    },
    getWidth(field) {
      return field.hasOwnProperty("width") ? `w-${field.width}` : "w-full";
    },
    addRow() {
      if (this.canAdd) {
        let object = {};
        this.config.forEach(field => {
          object[field.modelKey] = "";
        });
        this.value.push(object);
      }
    },
    deleteRow(row, index) {
      this.$emit("delete-row", {
        data: row,
        index
      });
      if (this.canDelete && !this.preventDelete) {
        this.value.splice(index, 1);
        this.error && this.error.splice(index, 1);
      }
    },
    formHasVisibleFields() {
      return this.config.reduce((prev, current) => {
        return (
          prev || !current.hasOwnProperty("condition") || current.condition()
        );
      }, false);
    },
    onChange(data, index) {
      this.$emit("change", {
        data: data.event,
        modelKey: data.modelKey,
        index
      });
    }
  }
};
</script>
